import { render, staticRenderFns } from "./ScaleComponent.vue?vue&type=template&id=5045867a&scoped=true"
import script from "./ScaleComponent.vue?vue&type=script&lang=js"
export * from "./ScaleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5045867a",
  null
  
)

export default component.exports